import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react";
import { Modal } from "@/atoms-react/modal/index.react";
import { Base } from "@/atoms-react/text/Text.react";
import type React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HeaderLevelModal } from "./header.react";
import { Button } from "@/atoms-react/button/Button.react";
import { KYCStatusType } from "@/features/kyc/types";
import { DocumentsLevel } from "./uploadDoc/index.react";
import { Themes } from "@/types/theme";
import { useNavigate } from "react-router-dom";
import { FileIcon, defaultStyles } from "react-file-icon";
import { useDocument } from "@/features/user/document/hooks/use-document";
import toast from "react-hot-toast";
import { DocumentRow } from "../document-row/index.react";
import type { Document } from "@/features/user/document/types";

enum ModalLevel {
  Start,
  AddDocuments,
  End
}
type ModalIbanAccountProps = {
  isOpen: boolean;
  onClose: () => void;
  statusClicked: KYCStatusType;
  title: string;
} & React.ComponentPropsWithoutRef<"div">;

export const ModalLevelObtain = ({
  isOpen,
  onClose,
  statusClicked,
  title
}: ModalIbanAccountProps) => {
  const { t } = useTranslation(["pass"]);
  const navigate = useNavigate();
  //const { status, kycLevel, kycAuditLevel } = useKYCContext()
  const [step, setStep] = useState<ModalLevel>(ModalLevel.Start);
  const extension = "pdf";
  const { updateUserUnderAuditMutation } = useDocument();
  const { mutateAsync: updateLevel, isPending: loading } = updateUserUnderAuditMutation();
  const [newDocs1, setNewDocs1] = useState<Document[] | []>([]);
  const [newDocs2, setNewDocs2] = useState<Document[] | []>([]);

  const handleSetNewDocs1 = (docs: Document[]) => {
    setNewDocs1(docs);
  };
  const handleSetNewDocs2 = (docs: Document[]) => {
    setNewDocs2(docs);
  };
  const handleUpdateStatus = async () => {
    try {
      const response = await updateLevel();

      if (response.success === false) {
        toast.error("error");
      }
      toast.success("success");
      onClose();
      window.location.reload();
    } catch (_) {
      toast.error("error");
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        onClose();
        setNewDocs1([]);
        setNewDocs2([]);

        setStep(ModalLevel.Start);
      }}
      className="w-full min-w-xl max-w-xl sm:w-full"
    >
      <div className="flex h-auto flex-col justify-between">
        {step === ModalLevel.Start && (
          <>
            <HeaderLevelModal status={statusClicked} />
            <div className="mt-4 flex flex-row justify-center">
              <Base className="font-semibold text-black text-xl">
                {" "}
                {t("olkypass.general.level_modal_documents.title")}{" "}
              </Base>
              <Base className="font-semibold text-primary text-xl"> {title}</Base>
            </div>

            {statusClicked === KYCStatusType.AUTHENTICATED_BRONZE && (
              <div className="p-4">
                <div className="mt-4 flex flex-row justify-center text-center">
                  <Base className="font-semibold text-base text-slate-400">
                    {t("olkypass.general.level_modal_documents.description")}
                    <Base className="font-semibold text-base text-primary">
                      {" "}
                      {t("olkypass.general.level_modal_documents.description_bronze_2")}
                    </Base>
                  </Base>
                </div>
                <div className="mt-4 flex flex-row justify-center text-center">
                  <Base className="font-semibold text-base text-slate-400">
                    {t("olkypass.general.level_modal_documents.description_3")}
                  </Base>
                </div>

                <div className="mt-10 flex flex-row justify-center">
                  <div className="flex flex-col justify-start">
                    <div className="flex flex-row">
                      <div className="mr-4 w-4 min-w-4">
                        {" "}
                        <FileIcon
                          extension={extension}
                          {...(extension ? defaultStyles[extension] : {})}
                        />
                      </div>
                      <Base className="font-semibold text-base text-black">
                        {t("olkypass.general.level_modal_documents.doc_bronze_1")}
                      </Base>
                    </div>
                    <div className="mt-2 flex flex-row">
                      <div className="mr-4 w-4 min-w-4">
                        {" "}
                        <FileIcon
                          extension={extension}
                          {...(extension ? defaultStyles[extension] : {})}
                        />
                      </div>
                      <Base className="font-semibold text-base text-black">
                        {t("olkypass.general.level_modal_documents.doc_bronze_2")}
                      </Base>
                    </div>{" "}
                  </div>
                </div>
              </div>
            )}
            {statusClicked === KYCStatusType.AUTHENTICATED_SILVER && (
              <div>
                <div className="mt-4 flex flex-row justify-center text-center">
                  <Base className="font-semibold text-base text-slate-400">
                    {t("olkypass.general.level_modal_documents.description")}

                    <Base className="font-semibold text-base text-primary">
                      {" "}
                      {t("olkypass.general.level_modal_documents.description_silver_2")}
                    </Base>
                  </Base>
                </div>
                <div className="mt-4 flex flex-row justify-center text-center">
                  <Base className="font-semibold text-base text-slate-400">
                    {t("olkypass.general.level_modal_documents.description_3")}
                  </Base>
                </div>

                <div className="mt-10 flex flex-row justify-center">
                  <div className="flex flex-col justify-start">
                    <div className="flex flex-row">
                      <div className="mr-4 w-4 min-w-4">
                        {" "}
                        <FileIcon
                          extension={extension}
                          {...(extension ? defaultStyles[extension] : {})}
                        />
                      </div>
                      <Base className="font-semibold text-base text-black">
                        {t("olkypass.general.level_modal_documents.doc_silver")}
                      </Base>
                    </div>{" "}
                  </div>
                </div>
              </div>
            )}
            {statusClicked === KYCStatusType.AUTHENTICATED_GOLD && (
              <div>
                <div className="mt-4 flex flex-row justify-center text-center">
                  <Base className="font-semibold text-base text-slate-400">
                    {t("olkypass.general.level_modal_documents.description")}

                    <Base className="font-semibold text-base text-primary">
                      {" "}
                      {t("olkypass.general.level_modal_documents.description_gold_2")}
                    </Base>
                  </Base>
                </div>
                <div className="mt-4 flex flex-row justify-center text-center">
                  <Base className="font-semibold text-base text-slate-400">
                    {t("olkypass.general.level_modal_documents.description_gold1")}
                  </Base>
                </div>
              </div>
            )}
            {statusClicked === KYCStatusType.AUTHENTICATED_GOLD ? (
              <Button
                className="mt-10"
                onClick={() => {
                  navigate("/pass/support");
                }}
              >
                {t("olkypass.general.level_modal_documents.gold_form_button")}
              </Button>
            ) : (
              <Button
                className="mt-10"
                onClick={() => {
                  setStep(
                    KYCStatusType.AUTHENTICATED_BRONZE === statusClicked
                      ? ModalLevel.AddDocuments
                      : ModalLevel.End
                  );
                }}
              >
                {t("olkypass.general.continue")}
              </Button>
            )}
          </>
        )}

        {step === ModalLevel.AddDocuments && (
          <>
            <HeaderLevelModal status={statusClicked} />
            <div className="p-4">
              <div>
                <Base className="mt-4 font-semibold text-base text-black">
                  {t("olkypass.general.level_modal_documents.doc_bronze_description")}
                </Base>

                <Base className="mt-2 font-semibold text-slate-400 text-sm">
                  {t("olkypass.general.level_modal_documents.doc_bronze_description2")}
                </Base>
              </div>
              <div className="mt-4">
                {newDocs1.length > 0 ? (
                  newDocs1.map((document, index) => (
                    <DocumentRow document={document} key={index} className="rounded-sm" />
                  ))
                ) : (
                  <>
                    {/* You get the document type from the DB*/}
                    <DocumentsLevel documentsType={53} handleNewDoc={handleSetNewDocs1} />
                  </>
                )}
              </div>
            </div>
            <div className="mt-5 flex flex-row justify-between">
              <Button
                className="ml-3 text-black"
                theme={Themes.declarative}
                size={"md"}
                onClick={() => {
                  setStep(ModalLevel.Start);
                }}
              >
                {t("olkypass.general.return")}
              </Button>
              <Button
                className="ml-2"
                size={"md"}
                disabled={!newDocs1 || newDocs1.length === 0}
                loading={statusClicked === KYCStatusType.AUTHENTICATED_SILVER && loading}
                onClick={() => {
                  setStep(ModalLevel.End);
                }}
              >
                {t("olkypass.general.continue")}
              </Button>
            </div>
          </>
        )}

        {step === ModalLevel.End && (
          <>
            <HeaderLevelModal status={statusClicked} />
            <div className="p-4">
              <div>
                <Base className="mt-4 font-semibold text-base text-black">
                  {t("olkypass.general.level_modal_documents.doc_title_step_3")}
                </Base>
              </div>
              <div className="mt-6 flex flex-row justify-center">
                <div className="mr-4 w-6 min-w-6">
                  {" "}
                  <FileIcon
                    extension={extension}
                    {...(extension ? defaultStyles[extension] : {})}
                  />
                </div>

                <a
                  target="_blank"
                  href="/document/Déclaration source patrimoine-V2.pdf"
                  className="font-semibold text-primary underline"
                  rel="noopener"
                >
                  {t("olkypass.general.level_modal_documents.button_form_download")}
                </a>
              </div>
              <div>
                <Base className="mt-8 font-semibold text-base text-black">
                  {t("olkypass.general.level_modal_documents.button_subtitle")}
                </Base>
              </div>
              <div className="mt-4">
                {newDocs2.length > 0 ? (
                  newDocs2.map((document, index) => (
                    <DocumentRow document={document} key={index} className="rounded-sm" />
                  ))
                ) : (
                  <DocumentsLevel documentsType={54} handleNewDoc={handleSetNewDocs2} />
                )}{" "}
              </div>
            </div>
            <div className="mt-5 flex flex-row justify-between">
              <Button
                className="ml-3 text-black"
                theme={Themes.declarative}
                size={"md"}
                onClick={() => {
                  if (statusClicked === KYCStatusType.AUTHENTICATED_BRONZE)
                    setStep(ModalLevel.AddDocuments);
                  if (statusClicked === KYCStatusType.AUTHENTICATED_SILVER)
                    setStep(ModalLevel.Start);
                }}
              >
                {t("olkypass.general.return")}
              </Button>
              <Button
                className="ml-10"
                disabled={!newDocs2 || newDocs2.length === 0}
                loading={loading}
                size={"md"}
                onClick={() => {
                  if (statusClicked === KYCStatusType.AUTHENTICATED_BRONZE) handleUpdateStatus();
                }}
              >
                {t("olkypass.general.finish")}
              </Button>
            </div>
          </>
        )}
        <div className="justify-content-center mt-12 flex flex-row justify-center">
          <DotsNavigation
            total={statusClicked === KYCStatusType.AUTHENTICATED_BRONZE ? 3 : 2}
            current={step}
          />
        </div>
      </div>
    </Modal>
  );
};
